import defaultFeatures from "@resources/psm-client-features.json";
import { ENVIRONMENT_ENVS } from "../constants/environment";
import type { Environment, EnvironmentEnv } from "../types";

declare global {
  interface Window {
    __ENV__?: Environment;
  }
}

/**
 * Get environment configuration from window.__ENV__ or defaults for local dev.
 *
 * Can be overridden locally via environment variables in .env.local:
 * - VITE_ENV_ENV: Override the env value (e.g., "LOCAL", "DEV", "DQS", "PROD")
 * - VITE_ENV_INTERNAL: Override the internal flag (true/false)
 *
 * In deployed environments (DEV/DQS/PROD), window.__ENV__ is loaded from /env.js
 * and provides actual git commit info and internal flag based on client IP.
 */
export const getEnvironment = (): Environment => {
  if (window.__ENV__) {
    return window.__ENV__;
  }

  // VITE_ENV_ENV override or "LOCAL" default
  const env: EnvironmentEnv = ENVIRONMENT_ENVS.includes(import.meta.env.VITE_ENV_ENV)
    ? import.meta.env.VITE_ENV_ENV
    : "LOCAL";

  // VITE_ENV_INTERNAL override or DEV mode default
  const internal =
    import.meta.env.VITE_ENV_INTERNAL !== undefined
      ? import.meta.env.VITE_ENV_INTERNAL === "true"
      : import.meta.env.DEV;

  // Default for local development when backend is not running
  return {
    env,
    internal,
    features: defaultFeatures,
  };
};
